var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 74",
    width: 65,
    height: 63,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "review-star-icon-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 38,
    y1: 185.7,
    x2: 38,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffde00"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: url(#g1) } \r\n\t\t.s1 { fill: none;stroke: #fff6c8;stroke-width: 5 } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m38 59.3l13.7 7.1c4.1 2.2 8.9-1.3 8.1-5.9l-2.6-15.1 11.1-10.7c3.3-3.3 1.5-8.9-3.1-9.6l-15.3-2.2-6.8-13.8c-2.1-4.1-8.1-4.1-10.2 0l-6.8 13.8-15.3 2.2c-4.6 0.7-6.4 6.3-3.1 9.6l11.1 10.7-2.6 15.1c-0.8 4.6 4 8.1 8.1 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m50.5 68.6c5.9 3.2 13-1.9 11.8-8.5l-2.4-13.8 10.1-9.8c4.9-4.7 2.2-12.9-4.5-13.9l-0.3 2.5 0.3-2.5-14-2-6.2-12.6c-3-6-11.6-6-14.6 0l-6.2 12.6-14 2c-6.7 1-9.4 9.2-4.5 13.9l10.1 9.8-2.4 13.8c-1.2 6.6 5.9 11.7 11.8 8.5l12.5-6.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStarIcon);
export default __webpack_public_path__ + "static/media/review-star-icon.2e18aa3a143487cb72280c3cb7ce11c6.svg";
export { ForwardRef as ReactComponent };